import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import type { membershipApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const patchMembership = http.patch<{ membershipId: string }, membershipApi.MembershipUpdateRequest, undefined>(
  apiBaseUrl + '/memberships/:membershipId',
  async ({ request, params }) => {
    const body = await request.json()
    console.log('PATCH Membership', params.membershipId, body)
    if (body.userId === 'BADREQUEST') {
      const responseError: membershipApi.ErrorBadRequest = {
        status: 400,
        title: 'Errore Bad Request',
        type: 'urn:badreq',
        rc: 404,
      }
      return HttpResponse.json(responseError, { status: 404 })
    }
    return HttpResponse.text(undefined, { status: 204 })
  },
)
